// InputPhone.jsx
import React, { Fragment, forwardRef, useRef, useImperativeHandle } from "react";
import { FormControl, InputLabel, Typography } from "@mui/material";
import Colors from "assets/Style/Colors";
import { Controller } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/bootstrap.css';

const InputPhone = forwardRef(function InputPhone(props, ref) {
  const {
    label, disabled, size, name, control, height, rules, error,
    onBlur, disableDropdown, countryCodeEditable, borderRadius // Added borderRadius here
  } = props;

  // ref to the underlying <input>
  const innerInputRef = useRef(null);

  // expose a clean imperative API to the parent (optional)
  useImperativeHandle(ref, () => ({
    focus: () => innerInputRef.current?.focus(),
    clear: () => {
      // parent can call ref.current.clear()
      // and we reset via RHF's onChange (see below)
    }
  }));

  return (
    <Fragment>
      <InputLabel sx={{ color:'#323B4B' }} error={!!error}>{label}</InputLabel>
      <FormControl variant="standard" fullWidth sx={{ mb: 2 }}>
        <Controller
          name={name}
          control={control}
          rules={rules}
          render={({ field }) => (
            <PhoneInput
              country="ae"
              disabled={disabled}
              // map RHF field explicitly
              value={field.value ?? ""}
              onChange={(val) => field.onChange(val)}
              onBlur={(e) => { field.onBlur(); onBlur?.(e); }}
              // pass the ref to the real input element
              inputProps={{ ref: innerInputRef, name: field.name }}
              disableDropdown={disableDropdown}
              countryCodeEditable={countryCodeEditable}
              containerStyle={{ marginTop: '8px' }}
              inputStyle={{
                width: '100%',
                borderColor: error ? Colors.danger : undefined,
                boxShadow: 'none',
                height: height || '',
                borderRadius: borderRadius || '4px' // Default value is '4px' if not provided
              }}
              isValid={(value, country) => {
                if (value.match(/12345/)) return 'Invalid value: ' + value + ', ' + country.name;
                if (value.match(/1234/))  return false;
                return true;
              }}
            />
          )}
        />
        {!!error && (
          <Typography color="error" sx={{ fontSize: 12, textAlign: 'left' }}>
            {error}
          </Typography>
        )}
      </FormControl>
    </Fragment>
  );
});

export default InputPhone;
